import Vue from "vue";
export var PaginationEventBus = new Vue();